<div class="chat">
  <p-splitter
    [panelSizes]="[83, 17]"
    [minSizes]="[25, 17]"
    stateKey="ask-navi-chat-splitter"
    stateStorage="local"
    layout="vertical"
    styleClass="chat-splitter chat-splitter-fill"
    class="chat-splitter-host"
    [style]="{ height: '100%' }"
  >
    <ng-template #panel>
      <div class="chat-scroll-container">
        <bds-scroll-region
          class="chat-messages-scroll-region"
          styleClass="chat-messages-scroll"
          ariaLabel="Ask Navi messages"
        >
          @if (state.showWelcome()) {
            <an-ask-navi-welcome (promptSelect)="onPromptSelect($event)" />
          } @else {
            <div class="chat-messages">
              @if (state.isLoadingMessages()) {
                <p class="loading">Loading messages…</p>
              }
              @for (message of state.messages(); track message.id) {
                @if (!isHiddenStreamingPlaceholder(message)) {
                  <an-ask-navi-message
                    [message]="message"
                    copilotName="Navi"
                    [userDisplayName]="state.userDisplayName()"
                    [userInitials]="state.userInitials()"
                    [showThinkingBelow]="message.metadata?.['streamPaused'] === true"
                  />
                }
              }
              @if (state.showThinking()) {
                <div class="relative message assistant thinking">
                  <div class="flex-shrink-0 w-8 h-8 rounded-full avatar assistant">
                    <img
                      src="assets/copilot/brightside_bug.png"
                      alt="Navi"
                      class="w-full h-full rounded-full object-cover"
                    />
                  </div>
                  <div class="flex gap-2 mb-1 text-xs text-surface-500 meta">
                    <span class="font-semibold capitalize role">Navi</span>
                    <span class="timestamp">now</span>
                  </div>
                  <div class="italic text-surface-600 thinking-dots content">
                    Navi is thinking<span class="dot">.</span><span class="dot">.</span><span
                      class="dot"
                      >.</span
                    >
                  </div>
                </div>
              }
              <div #messagesEnd></div>
            </div>
          }

          @if (state.errorMessage()) {
            <p class="chat__error" role="alert">{{ state.errorMessage() }}</p>
          }
        </bds-scroll-region>
      </div>
    </ng-template>

    <ng-template #panel>
      <form class="chat-input" (ngSubmit)="onSend()">
        <div class="chat-input__composer">
          <textarea
            class="chat-input__textarea"
            [ngModel]="state.draftInput()"
            (ngModelChange)="onDraftChange($event)"
            (keydown)="onKeydown($event)"
            name="message"
            placeholder="Message Ask Navi"
            rows="3"
            [disabled]="state.isStreaming()"
          ></textarea>
          <div class="chat-input__actions">
            <p-button
              type="submit"
              label="Send"
              icon="pi pi-arrow-up"
              [disabled]="!state.draftInput().trim() || state.isStreaming()"
              styleClass="p-button-outlined"
            />
          </div>
        </div>
      </form>
    </ng-template>
  </p-splitter>
</div>
